"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var idbstorage_1 = require("@wora/cache-persist/lib/idbstorage");
var ApolloClientOffline_1 = require("./ApolloClientOffline");
var apollo_cache_1 = require("@wora/apollo-cache");
var ApolloClientIDB = (function () {
    function ApolloClientIDB() {
    }
    ApolloClientIDB.create = function (config, options) {
        if (options === void 0) { options = {}; }
        var cacheOptions = options.cacheOptions, _a = options.persistOptions, persistOptions = _a === void 0 ? {} : _a, _b = options.offlineStoreOptions, offlineStoreOptions = _b === void 0 ? {} : _b, _c = options.idbOptions, idbOptions = _c === void 0 ? {} : _c;
        var idbStore = tslib_1.__assign({ serialize: false, prefix: null }, persistOptions);
        var idbOffline = tslib_1.__assign({ serialize: false, prefix: null }, offlineStoreOptions);
        if (typeof window !== 'undefined') {
            var _d = idbOptions.name, name_1 = _d === void 0 ? 'apollo' : _d, onUpgrade = idbOptions.onUpgrade, version = idbOptions.version;
            var idbStorages = idbstorage_1.IDBStorage.create({
                name: name_1,
                storeNames: ['store', 'offline'],
                onUpgrade: onUpgrade,
                version: version,
            });
            idbStore.storage = idbStorages[0];
            idbOffline.storage = idbStorages[1];
        }
        var cache = new apollo_cache_1.ApolloCache(cacheOptions, idbStore);
        return new ApolloClientOffline_1.ApolloClientOffline(tslib_1.__assign(tslib_1.__assign({}, config), { cache: cache }), idbOffline);
    };
    return ApolloClientIDB;
}());
exports.ApolloClientIDB = ApolloClientIDB;
exports.default = ApolloClientIDB;
//# sourceMappingURL=ApolloClientIDB.js.map